<!--
  AI-JAVADOC: WfProcessStepActivityUfFlowComponent Template
  Module: WF (Workflow)
  Description: Renders a UF flow component as a workflow activity. Shows loading state,
               error state, completion state, and the embedded mvs-uf-flow component.
-->
@if (initialized) {

    <!-- Activity description -->
    @if (activityType && activityType.description) {
        <div class="card quickview --workflowS">
            <div [innerHTML]="activityType.description | mvsSavePipe:'html'"></div>
        </div>
    }

    <!-- Error state: flow start failed -->
    @if (flowStartError) {
        <div class="flex flex-column gap-1 p-3 border-round surface-100 text-red-600">
            <div class="flex align-items-center gap-2">
                <i class="fa-regular fa-circle-exclamation"></i>
                <span class="text-lg font-semibold">Ablauf konnte nicht gestartet werden</span>
            </div>
            <div class="text-sm ml-4 text-color-secondary">{{ flowStartErrorMessage || 'Bitte versuchen Sie es später erneut.' }}</div>
        </div>
    }

    <!-- Loading state -->
    @if (busy) {
        <div class="flex align-items-center justify-content-center p-5">
            <i class="fa-regular fa-spinner fa-spin mr-2"></i>
            <span>Ablauf wird gestartet...</span>
        </div>
    }

    <!-- Flow completed state -->
    @if (flowCompleted) {
        <div class="flex align-items-center gap-2 p-3 border-round surface-100 text-green-600">
            <i class="fa-regular fa-circle-check"></i>
            <span>Ablauf wurde erfolgreich abgeschlossen.</span>
        </div>
    }

    <!-- UF Flow Component -->
    @if (!busy && !flowStartError && ufFlowObjectIdentifier && !flowCompleted) {
        <mvs-uf-flow
            [objectIdentifier]="ufFlowObjectIdentifier"
            [fullPage]="false"
            (onFlowComplete)="onFlowCompleted($event)"
            (onFlowCancelled)="onFlowCancelled($event)">
        </mvs-uf-flow>
    }

}
